"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * 沪深港通首页
 */
var searchnewsbox_1 = __importDefault(require("../../src/modules/searchnewsbox"));
var base_1 = __importDefault(require("./base"));
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
require("../../src/modules/bkselector/web");
var wconfig = require('../../config/web.js');
function makedata(data) {
    var datalength = data.length;
    var spaceNum = Math.floor(datalength / 4);
    var times = [], jlr_h = [], jlr_s = [], zjed_h = [], zjed_s = [], jlr_z = [], lastitem = [], b = true;
    for (var i = datalength - 1; i >= 0; i--) {
        var item = data[i].split(',');
        if (i == 0 || i == spaceNum || i == 2 * spaceNum || i == 3 * spaceNum || i == (datalength - 1)) {
            times[i] = { "value": item[0], "showline": true, "show": true };
        }
        else {
            times[i] = { "value": item[0], "showline": false, "show": false };
        }
        jlr_h[i] = fieldtools_1["default"].isEmpty(item[1]) ? "" : fieldtools_1["default"].fieldfmt(item[1], { zoom: -4, num: 2 });
        jlr_s[i] = fieldtools_1["default"].isEmpty(item[3]) ? "" : fieldtools_1["default"].fieldfmt(item[3], { zoom: -4, num: 2 });
        zjed_h[i] = fieldtools_1["default"].isEmpty(item[2]) ? "" : fieldtools_1["default"].fieldfmt(item[2], { zoom: -4, num: 2 });
        zjed_s[i] = fieldtools_1["default"].isEmpty(item[4]) ? "" : fieldtools_1["default"].fieldfmt(item[4], { zoom: -4, num: 2 });
        jlr_z[i] = fieldtools_1["default"].isEmpty(item[5]) ? "" : fieldtools_1["default"].fieldfmt(item[5], { zoom: -4, num: 2 });
        if (b && !fieldtools_1["default"].isEmpty(item[1]) && !fieldtools_1["default"].isEmpty(item[2]) && !fieldtools_1["default"].isEmpty(item[3]) && !fieldtools_1["default"].isEmpty(item[4])) {
            lastitem = item;
            b = false;
        }
    }
    return { "times": times, "jlr_h": jlr_h, "jlr_s": jlr_s, "zjed_h": zjed_h, "zjed_s": zjed_s, "jlr_z": jlr_z, "lastitem": lastitem };
}
function zjl_datafmt(data, fix) {
    return fieldtools_1["default"].fieldfmt(data, { zoom: 4, showcolor: true, num: 2, fix: fix });
}
// 搜素新闻的模块
searchnewsbox_1["default"]({
    dom: '.infolistBox',
    key: '沪深港通',
    header: '沪深港通',
    infolist_eventcode: 'sjpd_hsgtzjl_hsgtjd_wzqydjzh',
    more_eventcode: 'sjpd_hsgtzjl_hsgtjd_djgd'
});
console.log(base_1["default"]);
var hsgt_home = {
    init: function () {
        var _this = this;
        this.set_zfb_link();
        this.load_zfb_table();
        this.load_lszs(1, 1);
        this.load_lszs(2, 1);
        this.change_lszs();
        this.load_top10_table();
        this.load_ggph_table();
        this.load_bkph_chart();
        this.load_bkph_table();
        this.load_hsgtls();
        $('input[type=radio][name=chart]').change(function () {
            _this.load_bkph_chart($(this).data("type"));
        });
    },
    load_drzjlx: function () {
        var _this = this;
        //资金净买额
        //52:沪买入额  53:沪卖出额  54:沪净买额    56:深买入额    57:深卖出额   58:深净买额    60:总买入额    61:总卖出额    62:总净买额
        $.ajax({
            type: "get",
            url: wconfig.getWebPath('quoteurl') + "api/qt/kamtbs.rtmin/get?fields1=f1,f2,f3,f4&fields2=f51,f54,f52,f58,f53,f62,f56,f57,f60,f61&ut=b2884a393a59ad64002292a3e90d46a5",
            dataType: "jsonp",
            jsonp: 'cb',
            success: function (json) {
                _this.showJme(json);
            },
            error: function (err) {
                console && console.log(err);
            }
        });
        //资金净流入+资金余额
        $.ajax({
            type: "get",
            url: wconfig.getWebPath('quoteurl') + "api/qt/kamt.rtmin/get?fields1=f1,f2,f3,f4&fields2=f51,f52,f53,f54,f55,f56&ut=b2884a393a59ad64002292a3e90d46a5",
            dataType: "jsonp",
            jsonp: 'cb',
            success: function (json) {
                _this.showZjl(json);
            },
            error: function (err) {
                console && console.log(err);
            }
        });
        $("#north_filter li").on("click", function () {
            $("#north_filter li").removeClass("at");
            $(this).addClass("at");
            var val = $(this).data("value");
            $(".contentBxzj .echart_cont").hide();
            $(".contentBxzj .chart-data-cont").hide();
            $("#" + val + "_chart").show();
            var type = val == "north_zjye" ? "north_jlr" : val;
            $("#" + type + "_data").show();
        });
        $("#south_filter li").on("click", function () {
            $("#south_filter li").removeClass("at");
            $(this).addClass("at");
            var val = $(this).data("value");
            $(".contentNxzj .echart_cont").hide();
            $(".contentNxzj .chart-data-cont").hide();
            $("#" + val + "_chart").show();
            var type = val == "south_zjye" ? "south_jlr" : val;
            $("#" + type + "_data").show();
        });
    },
    showJme: function (json) {
        var data = json.data;
        var cdata = {
            "north": makedata(data.s2n),
            "south": makedata(data.n2s) //南向数据
        };
        var cname = {
            "north": ["沪股通", "深股通", "北向资金"],
            "south": ["港股通（沪）", "港股通（深）", "南向资金"]
        };
        for (var key in cdata) {
            var chart_data = cdata[key];
            var series = [
                {
                    name: cname[key][0],
                    data: chart_data.jlr_h,
                    connectNulls: true,
                    symbol: "circle",
                    showSymbol: false,
                    itemStyle: {
                        color: "#2383fc"
                    },
                    lineStyle: {
                        width: 1
                    },
                    type: 'line'
                },
                {
                    name: cname[key][1],
                    data: chart_data.jlr_s,
                    connectNulls: true,
                    symbol: "circle",
                    showSymbol: false,
                    itemStyle: {
                        color: "#ff5bff"
                    },
                    lineStyle: {
                        width: 1
                    },
                    type: 'line'
                },
                {
                    name: cname[key][2],
                    data: chart_data.jlr_z,
                    connectNulls: true,
                    symbol: "circle",
                    showSymbol: false,
                    itemStyle: {
                        color: "#6b3906"
                    },
                    lineStyle: {
                        width: 1
                    },
                    type: 'line'
                },
            ];
            base_1["default"].drawchart_fs(key + "_jme_chart", chart_data.times, series); //净买额图
            var item = chart_data.lastitem;
            if (item && item.length > 9) {
                $("#" + key + "_h_jme").html(zjl_datafmt(item[1]));
                $("#" + key + "_h_mre").html(zjl_datafmt(item[2]));
                $("#" + key + "_h_mce").html(fieldtools_1["default"].fieldfmt(item[4], { zoom: 4, num: 2 }));
                $("#" + key + "_s_jme").html(zjl_datafmt(item[3]));
                $("#" + key + "_s_mre").html(zjl_datafmt(item[6]));
                $("#" + key + "_s_mce").html(fieldtools_1["default"].fieldfmt(item[7], { zoom: 4, num: 2 }));
                $("#" + key + "_jme").html(zjl_datafmt(item[5]));
                $("#" + key + "_mre").html(zjl_datafmt(item[8]));
                $("#" + key + "_mce").html(fieldtools_1["default"].fieldfmt(item[9], { zoom: 4, num: 2 }));
            }
            // $("#updateTime_bxzj").text(data.s2nDate);
            $("#updateTime_nxzj").text(data.n2sDate);
        }
    },
    showZjl: function (json) {
        var data = json.data;
        var cdata = {
            "north": makedata(data.s2n),
            "south": makedata(data.n2s) //南向数据
        };
        var cname = {
            "north": ["沪股通", "深股通", "北向资金"],
            "south": ["港股通（沪）", "港股通（深）", "南向资金"]
        };
        for (var key in cdata) {
            var chart_data = cdata[key];
            var series1 = [
                {
                    name: cname[key][0],
                    data: chart_data.jlr_h,
                    connectNulls: true,
                    symbol: "circle",
                    showSymbol: false,
                    itemStyle: {
                        color: "#2383fc"
                    },
                    lineStyle: {
                        width: 1
                    },
                    type: 'line'
                },
                {
                    name: cname[key][1],
                    data: chart_data.jlr_s,
                    connectNulls: true,
                    symbol: "circle",
                    showSymbol: false,
                    itemStyle: {
                        color: "#ff5bff"
                    },
                    lineStyle: {
                        width: 1
                    },
                    type: 'line'
                },
                {
                    name: cname[key][2],
                    data: chart_data.jlr_z,
                    connectNulls: true,
                    symbol: "circle",
                    showSymbol: false,
                    itemStyle: {
                        color: "#6b3906"
                    },
                    lineStyle: {
                        width: 1
                    },
                    type: 'line'
                },
            ];
            var series2 = [{
                    name: cname[key][0],
                    data: chart_data.zjed_h,
                    connectNulls: true,
                    symbol: "circle",
                    showSymbol: false,
                    itemStyle: {
                        color: "#2383fc"
                    },
                    lineStyle: {
                        width: 1
                    },
                    type: 'line'
                },
                {
                    name: cname[key][1],
                    data: chart_data.zjed_s,
                    connectNulls: true,
                    symbol: "circle",
                    showSymbol: false,
                    itemStyle: {
                        color: "#ff5bff"
                    },
                    lineStyle: {
                        width: 1
                    },
                    type: 'line'
                }];
            base_1["default"].drawchart_fs(key + "_jlr_chart", chart_data.times, series1); //净流入图
            base_1["default"].drawchart_fs(key + "_zjye_chart", chart_data.times, series2); //资金余额图
            var item = chart_data.lastitem;
            if (item && item.length > 4) {
                $("#" + key + "_1").html(zjl_datafmt(item[1], "元"));
                $("#" + key + "_2").html(zjl_datafmt(item[2], "元"));
                $("#" + key + "_3").html(zjl_datafmt(item[3], "元"));
                $("#" + key + "_4").html(zjl_datafmt(item[4], "元"));
                $("#" + key + "_5").html(zjl_datafmt(item[5], "元"));
            }
        }
    },
    load_lszs: function (DIRECTION_TYPE, TIME_TYPE) {
        var _this = this;
        $.ajax({
            type: "GET",
            url: wconfig.getWebPath('datacenter') + "securities/api/data/v1/get",
            dataType: "jsonp",
            data: {
                reportName: "RPT_MUTUAL_NETINFLOW_DETAILS",
                columns: "DIRECTION_TYPE,TRADE_DATE,NET_INFLOW_SH,NET_INFLOW_SZ,NET_INFLOW_BOTH,TIME_TYPE",
                token: "894050c76af8597a853f5b408b759f5d",
                client: "WEB",
                filter: '(DIRECTION_TYPE="' + DIRECTION_TYPE + '")(TIME_TYPE="' + TIME_TYPE + '")',
                sortColumns: "TRADE_DATE",
                sortTypes: "1"
            },
            success: function (json) {
                _this.showlsChart(json, DIRECTION_TYPE, TIME_TYPE);
            }
        });
        $.ajax({
            type: "GET",
            url: wconfig.getWebPath('datacenter') + "securities/api/data/v1/get",
            dataType: "jsonp",
            data: {
                reportName: "RPT_MUTUAL_NETINFLOW_STATISTICS",
                columns: "DIRECTION_TYPE,TOTAL_INFLOW_SH,TOTAL_INFLOW_SZ,TOTAL_INFLOW_BOTH,TIME_TYPE,HISTORY_INFLOW_SH,HISTORY_INFLOW_SZ,HISTORY_TOTAL_INFLOW",
                token: "894050c76af8597a853f5b408b759f5d",
                client: "WEB",
                filter: '(DIRECTION_TYPE="' + DIRECTION_TYPE + '")(TIME_TYPE="' + TIME_TYPE + '")'
            },
            success: function (json) {
                _this.showlsText(json, DIRECTION_TYPE, TIME_TYPE);
            }
        });
    },
    change_lszs: function () {
        var _this = this;
        $("#north_ls_filter li").on("click", function () {
            $("#north_ls_filter li").removeClass("at");
            $(this).addClass("at");
            var val = $(this).data("value");
            _this.load_lszs(1, val);
        });
        $("#south_ls_filter li").on("click", function () {
            $("#south_ls_filter li").removeClass("at");
            $(this).addClass("at");
            var val = $(this).data("value");
            _this.load_lszs(2, val);
        });
    },
    showlsChart: function (json, DIRECTION_TYPE) {
        var datas = json && json.result && json.result.data;
        if (datas) {
            var lsDate = [], shdata = [], szdata = [], hsdata = [];
            for (var i = 0; i < datas.length; i++) {
                var data = datas[i];
                lsDate[i] = fieldtools_1["default"].dateformat(data.TRADE_DATE);
                shdata[i] = fieldtools_1["default"].fieldfmt(data.NET_INFLOW_SH, { zoom: -2 });
                szdata[i] = fieldtools_1["default"].fieldfmt(data.NET_INFLOW_SZ, { zoom: -2 });
                hsdata[i] = (fieldtools_1["default"].isEmpty(data.NET_INFLOW_SH) || fieldtools_1["default"].isEmpty(data.NET_INFLOW_SZ)) ? "" : fieldtools_1["default"].fieldfmt(data.NET_INFLOW_BOTH, { zoom: -2 });
            }
            //获得最新的日期
            var newDate = fieldtools_1["default"].dateformat(lsDate[(lsDate.length - 1)], "MM-DD");
            if (DIRECTION_TYPE == 1) {
                $("#updateTime_bxzjlszs").text(newDate);
                var series = [
                    {
                        name: "沪股通",
                        data: shdata,
                        connectNulls: true,
                        symbol: "circle",
                        showSymbol: false,
                        itemStyle: {
                            color: "#2383fc"
                        },
                        lineStyle: {
                            width: 1
                        },
                        type: 'line'
                    },
                    {
                        name: "深股通",
                        data: szdata,
                        connectNulls: true,
                        symbol: "circle",
                        showSymbol: false,
                        itemStyle: {
                            color: "#ff5bff"
                        },
                        lineStyle: {
                            width: 1
                        },
                        type: 'line'
                    },
                    {
                        name: "北向资金",
                        data: hsdata,
                        connectNulls: true,
                        symbol: "circle",
                        showSymbol: false,
                        itemStyle: {
                            color: "#6b3906"
                        },
                        lineStyle: {
                            width: 1
                        },
                        type: 'line'
                    },
                ];
                base_1["default"].drawchart_ls("north_ls_chart", lsDate, series);
            }
            else {
                $("#updateTime_nxzjlszs").text(newDate);
                var series = [
                    {
                        name: "港股通（沪）",
                        data: shdata,
                        connectNulls: true,
                        symbol: "circle",
                        showSymbol: false,
                        itemStyle: {
                            color: "#2383fc"
                        },
                        lineStyle: {
                            width: 1
                        },
                        type: 'line'
                    },
                    {
                        name: "港股通（深）",
                        data: szdata,
                        connectNulls: true,
                        symbol: "circle",
                        showSymbol: false,
                        itemStyle: {
                            color: "#ff5bff"
                        },
                        lineStyle: {
                            width: 1
                        },
                        type: 'line'
                    },
                    {
                        name: "南向资金",
                        data: hsdata,
                        connectNulls: true,
                        symbol: "circle",
                        showSymbol: false,
                        itemStyle: {
                            color: "#6b3906"
                        },
                        lineStyle: {
                            width: 1
                        },
                        type: 'line'
                    },
                ];
                base_1["default"].drawchart_ls("south_ls_chart", lsDate, series);
            }
        }
    },
    showlsText: function (json, DIRECTION_TYPE, TIME_TYPE) {
        var data = json && json.result && json.result.data && json.result.data[0];
        if (data) {
            var _tHtml = TIME_TYPE == 1 ? "近一月" : TIME_TYPE == 2 ? "近六月" : TIME_TYPE == 3 ? "近一年" : TIME_TYPE == 4 ? "" : "";
            var domidqz = DIRECTION_TYPE == 1 ? "bx" : "nx";
            var lshg = '<span class="fLeft">' + _tHtml + '净买入</span><span class="fLeft w90">' + fieldtools_1["default"].fieldfmt(data.TOTAL_INFLOW_SH, { zoom: 6, num: 2, fix: "元", showcolor: true })
                + "</span><span >历史净买入</span>" + fieldtools_1["default"].fieldfmt(data.HISTORY_INFLOW_SH, { zoom: 6, num: 2, fix: "元", showcolor: true });
            if (_tHtml == "")
                lshg = '<span class="fLeft">历史净买额</span><span class="fLeft w90">' + fieldtools_1["default"].fieldfmt(data.HISTORY_INFLOW_SH, { zoom: 6, num: 2, fix: "元", showcolor: true }) + "</span>";
            $("#" + domidqz + "_lshg").html(lshg);
            var lssg = '<span class="fLeft">' + _tHtml + '净买入</span><span class="fLeft w90">' + fieldtools_1["default"].fieldfmt(data.TOTAL_INFLOW_SZ, { zoom: 6, num: 2, fix: "元", showcolor: true })
                + "</span><span >历史净买入</span>" + fieldtools_1["default"].fieldfmt(data.HISTORY_INFLOW_SZ, { zoom: 6, num: 2, fix: "元", showcolor: true });
            if (_tHtml == "")
                lssg = '<span class="fLeft">历史净买额</span><span class="fLeft w90">' + fieldtools_1["default"].fieldfmt(data.HISTORY_INFLOW_SZ, { zoom: 6, num: 2, fix: "元", showcolor: true }) + "</span>";
            $("#" + domidqz + "_lssg").html(lssg);
            var ls = '<span class="fLeft">' + _tHtml + '净买入</span><span class="fLeft w90">' + fieldtools_1["default"].fieldfmt(data.TOTAL_INFLOW_BOTH, { zoom: 6, num: 2, fix: "元", showcolor: true })
                + "</span><span >历史净买入</span>" + fieldtools_1["default"].fieldfmt(data.HISTORY_TOTAL_INFLOW, { zoom: 6, num: 2, fix: "元", showcolor: true });
            if (_tHtml == "")
                ls = '<span class="fLeft">历史净买额</span><span class="fLeft w90">' + fieldtools_1["default"].fieldfmt(data.HISTORY_TOTAL_INFLOW, { zoom: 6, num: 2, fix: "元", showcolor: true }) + "</span>";
            $("#" + domidqz + "_lsbx").html(ls);
        }
    },
    set_zfb_link: function () {
        var mk_sdcjsj = $("#zfb_filter").find("li.at").text();
        if (mk_sdcjsj == "沪股通涨幅榜") {
            $(".zfb_more").attr("href", "//quote.eastmoney.com/center/gridlist.html?st=ChangePercent&sr=-1#sh_hk_board");
        }
        else if (mk_sdcjsj == "深股通涨幅榜") {
            $(".zfb_more").attr("href", "//quote.eastmoney.com/center/gridlist.html?st=ChangePercent&sr=-1#sz_hk_board");
        }
        else if (mk_sdcjsj == "港股通(沪)涨幅榜") {
            $(".zfb_more").attr("href", "//quote.eastmoney.com/center/gridlist.html#hk_sh_stocks");
        }
        else if (mk_sdcjsj == "港股通(深)涨幅榜") {
            $(".zfb_more").attr("href", "//quote.eastmoney.com/center/gridlist.html#hk_sz_stocks");
        }
        else {
            $(".zfb_more").attr("href", "//quote.eastmoney.com/center/gridlist.html#ah_comparison");
        }
    },
    load_zfb_table: function () {
        var _this = this;
        var opt = {
            dataurl: {
                hostname: 'quoteurl',
                url: 'api/qt/clist/get',
                params: {
                    pn: "1",
                    pz: "10",
                    po: "1",
                    fid: "f3",
                    fltt: "2",
                    invt: "2",
                    fields: "f1,f152,f12,f13,f14,f2,f3,f6,f8,f9,f20,f186,f187,f188,f189,f191,f192,f152",
                    ut: '8dec03ba335b81bf4ebdf7b29ec27d15'
                }
            },
            urlkeyvalues: {
                pagenumber: "pn",
                pagesize: "pz",
                sortname: "fid",
                sortorder: "po"
            },
            sortordervalues: { desc: 1, asc: 0 },
            datafield: "data.diff",
            totalfield: "data.total",
            pagenumber: 1,
            pagesize: 10,
            pagination: false,
            responseHandler: base_1["default"].makedata,
            filteroptions: [
                {
                    name: "fs",
                    fieldname: "fs",
                    filterselector: "#zfb_filter",
                    filtersoptionselector: "li",
                    values: function (value) {
                        return "" + value;
                    },
                    handle: function (filter, that) {
                        _this.set_zfb_link();
                        if (filter.value == "b:MK0144" || filter.value == "b:MK0146") {
                            that.refresh({ tabletype: "zfb_h" });
                            return false;
                        }
                        else if (filter.value == "b:MK0101") {
                            that.refresh({ tabletype: "ah" });
                            return false;
                        }
                        else {
                            that.refresh({ tabletype: "zfb_a" });
                            return false;
                        }
                        return true;
                    }
                }
            ],
            columns: base_1["default"]["zfb"].columns,
            formatter: { strfmt: true },
            scrolltop: false
        };
        $("#dataview_zfb").emdataview(opt);
    },
    load_top10_table: function () {
        var opt = {
            dataurl: {
                hostname: 'datacenter',
                url: 'api/data/v1/get',
                params: {
                    reportName: 'RPT_MUTUAL_TOP10DEAL',
                    columns: 'ALL',
                    pageNumber: 1,
                    pageSize: 10,
                    sortColumns: "TRADE_DATE,RANK",
                    sortTypes: "-1,1",
                    source: "WEB",
                    client: "WEB"
                }
            },
            pagination: false,
            urlkeyvalues: base_1["default"].urlkeyvalues,
            filteroptions: [
                {
                    name: "filter",
                    fieldname: "filter",
                    filterselector: "#top10_filter",
                    filtersoptionselector: "li",
                    values: function (value) {
                        return "(MUTUAL_TYPE=\"" + value + "\")";
                    },
                    handle: function (filter, that) {
                        var mapping = {
                            "001": ["沪股通", ""],
                            "003": ["深股通", ""],
                            "002": ["港股通(沪)", "(港元)"],
                            "004": ["港股通(深)", "(港元)"]
                        };
                        var text = mapping[filter.value];
                        that.updateColumnTitle([
                            { field: "NET_BUY_AMT", title: text[0] + "<br/>\u51C0\u4E70\u989D" + text[1] },
                            { field: "BUY_AMT", title: text[0] + "<br/>\u4E70\u5165\u91D1\u989D" + text[1] },
                            { field: "SELL_AMT", title: text[0] + "<br/>\u5356\u51FA\u91D1\u989D" + text[1] },
                            { field: "DEAL_AMT", title: text[0] + "<br/>\u6210\u4EA4\u91D1\u989D" + text[1] }
                        ]);
                        return true;
                    }
                }
            ],
            columns: base_1["default"]["top10"].columns,
            formatter: { strfmt: true },
            // queryparams: function (options, queryparams) {
            //     let param = $("#top10_filter li.at").data("value");
            //     let sty = param.split('_')[0];
            //     queryparams.data.sty = sty;
            //     queryparams.data.st = param.split('_')[1] == 4 ? "DetailDate,Rank1" : "DetailDate,Rank";
            //     return queryparams
            // },
            onPreBody: function (data, that) {
                $("#top10_date").html(fieldtools_1["default"].dateformat(data && data[0].TRADE_DATE));
                return true;
            },
            scrolltop: false
        };
        $("#dataview_top10").emdataview(opt);
    },
    load_ggph_table: function () {
        var opt = {
            dataurl: {
                hostname: 'datacenter',
                url: 'api/data/v1/get',
                params: {
                    reportName: 'RPT_MUTUAL_STOCK_NORTHSTA',
                    columns: 'ALL',
                    pageNumber: 1,
                    pageSize: 5,
                    source: "WEB",
                    client: "WEB",
                    filter: "(INTERVAL_TYPE=\"1\")(MUTUAL_TYPE in (\"001\",\"003\"))(TRADE_DATE='" + ggph_date + "')"
                }
            },
            pagination: false,
            sortname: 'ADD_MARKET_CAP',
            urlkeyvalues: base_1["default"].urlkeyvalues,
            columns: base_1["default"]["ggph_old"].columns,
            theadmoreurl: "/hsgtcg/list.html?st={field}",
            formatter: { strfmt: true },
            scrolltop: false
        };
        $("#dataview_ggph").emdataview(opt);
    },
    load_bkph_chart: function (type) {
        if (type === void 0) { type = "ADD_MARKET_CAP"; }
        $.ajax({
            url: wconfig.getWebPath('datacenter') + 'api/data/v1/get',
            type: 'GET',
            dataType: 'jsonp',
            data: {
                reportName: 'RPT_MUTUAL_BOARD_HOLDRANK_WEB',
                columns: 'ALL',
                sortColumns: type,
                sortTypes: -1,
                source: "WEB",
                client: "WEB",
                filter: "(BOARD_TYPE=\"5\")(INTERVAL_TYPE=\"1\")(TRADE_DATE='" + bkph_date + "')" //行业板块
            }
        }).then(function (json) {
            var _a;
            var datas = (_a = json === null || json === void 0 ? void 0 : json.result) === null || _a === void 0 ? void 0 : _a.data;
            ;
            datas = datas.sort(function (a, b) {
                return b[type] - a[type];
            });
            var names = [], ydatas = [], objs = {};
            for (var i = 0; i < datas.length; i++) {
                var item = datas[i];
                names.push(item.BOARD_NAME);
                ydatas.push(isFinite(parseFloat(item[type])) ? (item[type] * (type == "ADD_MARKET_CAP" ? 1 : 1000)) : undefined);
                objs[item.BOARD_NAME] = item;
            }
            var bkph_chart = base_1["default"].drawchart_bk("bkph_chart", names, ydatas, type);
            bkph_chart.on('click', function (params) {
                if (params.componentType == "xAxis")
                    window.open("/hsgtcg/" + objs[params.value]["SECURITY_CODE"] + ".html");
            });
        });
    },
    load_bkph_table: function () {
        var opt = {
            dataurl: {
                hostname: 'datacenter',
                url: 'api/data/v1/get',
                params: {
                    reportName: 'RPT_MUTUAL_BOARD_HOLDRANK_WEB',
                    columns: 'ALL',
                    pageNumber: 1,
                    pageSize: 5,
                    source: "WEB",
                    client: "WEB",
                    filter: "(BOARD_TYPE=\"5\")(INTERVAL_TYPE=\"1\")(TRADE_DATE='" + bkph_date + "')"
                }
            },
            pagination: false,
            sortname: 'ADD_MARKET_CAP',
            urlkeyvalues: base_1["default"].urlkeyvalues,
            columns: base_1["default"]["bkph"].columns,
            theadmoreurl: "/hsgtcg/hy.html?st={field}",
            formatter: { strfmt: true },
            scrolltop: false
        };
        $("#dataview_bkph").emdataview(opt);
    },
    load_hsgtls: function () {
        var opt = {
            dataurl: {
                hostname: 'datacenter',
                url: 'api/data/v1/get',
                params: {
                    reportName: 'RPT_MUTUAL_DEAL_HISTORY',
                    columns: 'ALL',
                    source: "WEB",
                    client: "WEB"
                }
            },
            sortname: 'TRADE_DATE',
            pagesize: 10,
            urlkeyvalues: base_1["default"].urlkeyvalues,
            columns: base_1["default"]["lssj"].columns,
            filteroptions: [
                {
                    name: "filter",
                    fieldname: "filter",
                    filterselector: "#lssj_filter",
                    filtersoptionselector: "li",
                    values: function (value) {
                        return "(MUTUAL_TYPE=\"" + value + "\")";
                    },
                    handle: function (filter, that) {
                        var mapping = {
                            "001": ["", "上证指数"],
                            "003": ["", "深证成指"],
                            "002": ["(港元)", "恒生指数"],
                            "004": ["(港元)", "恒生指数"]
                        };
                        var text = mapping[filter.value];
                        that.updateColumnTitle([
                            { field: "NET_DEAL_AMT", title: "\u5F53\u65E5\u6210\u4EA4<br/>\u51C0\u4E70\u989D" + text[0] + "<i class=\"icon icon_faq2\" title=\"\u5F53\u65E5\u6210\u4EA4\u51C0\u4E70\u989D=\u4E70\u5165\u6210\u4EA4\u989D-\u5356\u51FA\u6210\u4EA4\u989D\u3002\"></i>" },
                            { field: "BUY_AMT", title: "\u4E70\u5165\u6210\u4EA4\u989D" + text[0] },
                            { field: "SELL_AMT", title: "\u5356\u51FA\u6210\u4EA4\u989D" + text[0] },
                            { field: "INDEX_CLOSE_PRICE", title: "" + text[1] }
                        ]);
                        return true;
                    }
                }
            ],
            formatter: { strfmt: true },
            scrolltop: false
        };
        $("#dataview_lssj").emdataview(opt);
    }
};
function loadZjlxData() {
    base_1["default"].load_zjlx_table();
    hsgt_home.load_drzjlx();
}
loadZjlxData();
setInterval(loadZjlxData, 60000);
hsgt_home.init();
